import { type IBaseEntity } from "types/apiResponse/apiResponse";

import { APIHandler } from "utilities/apiHandler";

import {
    type IMassPoPaymentRequest,
    MassBillPayInFullResponse,
    MassBillPaymentResponse,
    MassBillPaymentValidationResponse,
} from "entity/massPoPayment/MassBillPayment/MassBillPayment.api.types";

export interface IMassBillPaymentHandler {
    get(
        selectedPurchaseOrders: IBaseEntity[],
        isOnlinePayment: boolean,
        selectedJobId?: number,
    ): Promise<MassBillPaymentResponse>;
    sendMassBillPay(request: IMassPoPaymentRequest): Promise<MassBillPayInFullResponse>;
    getAccountingValidation(poIds: number[]): Promise<MassBillPaymentValidationResponse>;
}

export class MassBillPaymentHandler implements IMassBillPaymentHandler {
    async get(
        selectedPurchaseOrders: IBaseEntity[],
        isOnlinePayment: boolean,
        selectedJobId?: number,
    ): Promise<MassBillPaymentResponse> {
        if (isOnlinePayment) {
            return await APIHandler("/api/OnlinePayments/MassBillPay", {
                method: "POST",
                responseType: MassBillPaymentResponse,
                data: {
                    selectedPurchaseOrders: selectedPurchaseOrders,
                    selectedJobId: selectedJobId,
                },
            });
        } else {
            return await APIHandler("/api/v1/bills/GetMassBillPayOffline", {
                method: "POST",
                responseType: MassBillPaymentResponse,
                data: {
                    selectedPurchaseOrders: selectedPurchaseOrders,
                    selectedJobId: selectedJobId,
                },
            });
        }
    }

    async sendMassBillPay(request: IMassPoPaymentRequest): Promise<MassBillPayInFullResponse> {
        return await APIHandler("/api/PurchaseOrders/MassPayOnline", {
            method: "POST",
            responseType: MassBillPayInFullResponse,
            data: request,
        });
    }

    async getAccountingValidation(poIds: number[]): Promise<MassBillPaymentValidationResponse> {
        return await APIHandler("/api/PurchaseOrders/ValidateAccountingForMassPay", {
            method: "GET",
            responseType: MassBillPaymentValidationResponse,
            data: {
                poIds: poIds.join(","),
            },
        });
    }
}
